<div class="flex justify-between">
  <div class="flex align-center gap-5 container-header">
      <img src="./assets/icones/box-happy.png" alt="">
      <div class="flex-direction-column gap-5">
        <span class="font-mobile">{{ nomeContato ?? '--' }}</span>
        <span class="font-mobile">{{ ( numeroContato | celularMask )?? '--' }}</span>
      </div>
  </div>
  <div>
    @if (sessao?.ativo && sessao?.tempoFinalizar && sessao?.dataFormatadaFinalizar && sessao?.dataFormatadaFinalizar !== '00:00') {
      <span class="font-mobile color-primary">Tempo de Finalização</span>
      <app-progress-bar-data
        [data]="sessao?.dataFormatadaFinalizar!"
        [tempoFinalizar]="sessao?.tempoFinalizar!"
        [verificaFinalizada]="true">
      </app-progress-bar-data>
    }
    @else if (sessao?.ativo && sessao?.dataFormatadaFinalizar && sessao?.dataFormatadaFinalizar === '00:00') {
      <span>Finalizado</span>
    }
  </div>
  @if (!isExibicao){
    <div class="flex-direction-row gap-5 align-center">
      <app-button-padrao iconSrc="icones/visualizar"
                         iconSrcExtensao=".svg"
                         width="5vw"
                         height="5vw"
                         widthIcon="5vw"
                         heightIcon="5vw"
                         backgroundColor="transparent"
                         (buttonClick)="abrirModalDetalhes()"
      >
      </app-button-padrao>
      <app-button-padrao iconSrc="icones/comentario-alt"
                         iconSrcExtensao=".svg"
                         width="5vw"
                         height="5vw"
                         widthIcon="5vw"
                         heightIcon="5vw"
                         backgroundColor="transparent"
                         (buttonClick)="abrirModalChat()"
      >
      </app-button-padrao>
      <app-button-padrao iconSrc="icones/dialogo"
                         iconSrcExtensao=".svg"
                         width="5vw"
                         height="5vw"
                         widthIcon="5vw"
                         heightIcon="5vw"
                         backgroundColor="transparent"
                         (buttonClick)="abrirModalEdicaoDetalhes()"
      >
      </app-button-padrao>
      @if (isAtivo) {
        <app-button-padrao
          iconSrc="icones/reinicio-icon"
          iconSrcExtensao=".svg"
          width="5vw"
          height="5vw"
          widthIcon="5vw"
          heightIcon="5vw"
          backgroundColor="transparent"
          [matTooltip]="'Reiniciar sessão'"
          (buttonClick)="abrirModalReiniciarSessao()"
        >
        </app-button-padrao>
      }
    </div>
  }
</div>
